import {
  HostingVisitsAction,
  LOAD_HOSTING_VISITS,
  LOAD_HOSTING_VISITS_BY_WEBSITE,
  LOAD_HOSTING_VISITS_BY_WEBSITE_BY_DATE,
  LOAD_HOSTING_VISITS_BY_WEBSITE_BY_DATE_FAIL,
  LOAD_HOSTING_VISITS_BY_WEBSITE_BY_DATE_SUCCESS,
  LOAD_HOSTING_VISITS_BY_WEBSITE_FAIL,
  LOAD_HOSTING_VISITS_BY_WEBSITE_SUCCESS,
  LOAD_HOSTING_VISITS_FAIL,
  LOAD_HOSTING_VISITS_SUCCESS,
  LoadHostingVisitsByWebsite,
  LoadHostingVisitsByWebsiteByDate,
  LoadHostingVisitsByWebsiteByDateFail,
  LoadHostingVisitsByWebsiteByDateSuccess,
  LoadHostingVisitsByWebsiteFail,
  LoadHostingVisitsByWebsiteSuccess,
  LoadHostingVisitsSuccess
} from "../actions";

export interface IHostingVisitsState {
  hostingVisits: any;
  entities: any;
  loading: boolean;
  loaded: boolean;
}

export const initialState: IHostingVisitsState = {
  hostingVisits: null,
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IHostingVisitsState = initialState, action: HostingVisitsAction): IHostingVisitsState {
  let payload: any;

  switch (action.type) {
    case LOAD_HOSTING_VISITS:
      return {
        ...state,
        loading: true,
        loaded: false
      };

    case LOAD_HOSTING_VISITS_SUCCESS:
      payload = (<LoadHostingVisitsSuccess>action).payload;

      return {
        ...state,
        hostingVisits: payload,
        loading: false,
        loaded: true
      };

    case LOAD_HOSTING_VISITS_FAIL:
      return {
        ...state,
        hostingVisits: null,
        loading: false,
        loaded: true
      };


    case LOAD_HOSTING_VISITS_BY_WEBSITE:
      payload = (<LoadHostingVisitsByWebsite>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...(state.entities ? state.entities[payload] : {}),
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_HOSTING_VISITS_BY_WEBSITE_SUCCESS:
      payload = (<LoadHostingVisitsByWebsiteSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            entities: payload.entities,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_HOSTING_VISITS_BY_WEBSITE_FAIL:
      payload = (<LoadHostingVisitsByWebsiteFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
    case LOAD_HOSTING_VISITS_BY_WEBSITE_BY_DATE:
      payload = (<LoadHostingVisitsByWebsiteByDate>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...(state.entities ? state.entities[payload] : {}),
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_HOSTING_VISITS_BY_WEBSITE_BY_DATE_SUCCESS:
      payload = (<LoadHostingVisitsByWebsiteByDateSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            entities: payload.entities,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_HOSTING_VISITS_BY_WEBSITE_BY_DATE_FAIL:
      payload = (<LoadHostingVisitsByWebsiteByDateFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };

  }

  return state;
}
